import React, { Component } from "react";
import validator from "validator";
//icons
import { IoIosCloseCircleOutline } from "react-icons/io";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { AiOutlineMinusCircle } from "react-icons/ai";
// Import social media icons
import { RiFacebookFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import loco from "../../images/games/loco.png";

//utils
import { capitalize } from "../../utils/common.utils";
import {
  baseUrls,
  handleTypes,
  socialMediaRegex,
  getPlatformDetails,
  validateSocialMediaUrl,
  generateSocialMediaPlaceholders,
  generateSocialMediaErrorMessages,
} from "../../utils/socialmedia.utils";

//css
import "../../styles/Organization.css";

class AddMoreDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socialFieldArr: this.props.data || [],
    };

    // Initialize social media placeholders and error messages
    this.socialMediaPlaceholders = generateSocialMediaPlaceholders(baseUrls, handleTypes);
    this.socialMediaErrorMessages = generateSocialMediaErrorMessages(baseUrls, handleTypes);
  }

  updateDetails = (e, i) => {
    let { socialFieldArr } = this.state;
    socialFieldArr[i].value = e.target.value;

    // Validate URL immediately when user types
    if (socialFieldArr[i].value !== "") {
      socialFieldArr[i].error = validateSocialMediaUrl(
        socialFieldArr[i].value,
        socialFieldArr[i].key
      );
    } else {
      socialFieldArr[i].error = "";
    }

    this.setState({ socialFieldArr });
  };

  handleClose = () => {
    this.props.addMoreDetails();
  };

  validateDetails = () => {
    let errors = 0;
    const filledFields = this.state.socialFieldArr.map(field => {
      let error = "";
      if (field.value !== "") {
        error = validateSocialMediaUrl(field.value, field.key);
      }
      if (error) {
        errors++;
      }
      return { ...field, error };
    });

    this.setState({ socialFieldArr: filledFields });
    if (errors > 0) {
      return false;
    } else {
      return true;
    }
  };

  passDetails = () => {
    if (this.validateDetails()) {
      // Filter out any fields that have errors before passing to parent
      const validFields = this.state.socialFieldArr.filter(field => !field.error);
      this.props.renderAddedDetails(validFields);
    }
  };

  showFields = (i, value) => {
    const newArray = [...this.state.socialFieldArr];
    let temp = { ...newArray[i] };
    temp.isChecked = value;
    if (!value) {
      temp.value = "";
      temp.error = "";
    }
    newArray[i] = temp;
    this.setState({ socialFieldArr: newArray });
  };

  render() {
    if (!this.state.socialFieldArr || this.state.socialFieldArr.length === 0) {
      return null;
    }

    return (
      <>
        <form className="m-3">
          <p className="fs-18 fw-bold text-white text-center mb-2">Add Social Media</p>
          <IoIosCloseCircleOutline
            className="close-icon position-absolute"
            style={{ right: "15px", top: "15px" }}
            onClick={this.handleClose}
          />
          <p className="fs-14 fw-600 text-center text-white-50 mb-0">
            Please select the social media platform you wish to connect.
          </p>
          <div className="row m-1">
            {this.state.socialFieldArr.map((el, i) => {
              const platformDetails = getPlatformDetails(el.key);
              const placeholder =
                el.isChecked && !el.value ? platformDetails.placeholder || "" : "";
              return el.isChecked ? (
                <div className="d-flex flex-column mb-2" key={i}>
                  <label htmlFor="facebook" className="fs-14 fw-600 text-white">
                    {capitalize(el.label)}
                  </label>
                  <div className="purple-field d-flex align-items-center">
                    {/* Render React icon based on key */}
                    {el.key === "instagram" && (
                      <AiFillInstagram
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "facebook" && (
                      <RiFacebookFill
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "x" && (
                      <FaXTwitter
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "twitch" && (
                      <FaTwitch
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "telegram" && (
                      <FaTelegramPlane
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "youtube" && (
                      <AiFillYoutube
                        className="mx-2"
                        style={{
                          width: "20px",
                          height: "auto",
                          color: "#fff",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    {el.key === "loco" && (
                      <img
                        src={loco}
                        className="mx-2"
                        alt="loco"
                        style={{
                          width: "20px",
                          height: "auto",
                          filter: "drop-shadow(0 0 4px #888)",
                        }}
                      />
                    )}
                    <input
                      type="text"
                      className="d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                      autoComplete="off"
                      onChange={e => this.updateDetails(e, i)}
                      value={el.value}
                      placeholder={placeholder}
                      style={{ backgroundColor: "transparent", outline: "none" }}
                    />
                    <AiOutlineMinusCircle
                      className="text-white me-2 cursor-pointer"
                      onClick={() => {
                        this.showFields(i, false);
                      }}
                    />
                  </div>
                  <p className="error-msg">{el.error}</p>
                </div>
              ) : (
                <div className="col-12 mb-2" key={i}>
                  <div
                    className="black-flat-btn d-flex flex-row align-items-center mx-auto height-45 rounded-10 mt-2 w-100 cursor-pointer"
                    onClick={() => {
                      this.showFields(i, true);
                    }}
                  >
                    {/* Render React icon based on key for add button */}
                    {el.key === "instagram" && (
                      <AiFillInstagram className="btn-size-20 ms-3 text-white" />
                    )}
                    {el.key === "facebook" && (
                      <RiFacebookFill className="btn-size-20 ms-3 text-white" />
                    )}
                    {el.key === "x" && <FaXTwitter className="btn-size-20 ms-3 text-white" />}
                    {el.key === "twitch" && <FaTwitch className="btn-size-20 ms-3 text-white" />}
                    {el.key === "telegram" && (
                      <FaTelegramPlane className="btn-size-20 ms-3 text-white" />
                    )}
                    {el.key === "youtube" && (
                      <AiFillYoutube className="btn-size-20 ms-3 text-white" />
                    )}
                    {el.key === "loco" && (
                      <img src={loco} alt="loco" className="btn-size-20 ms-3 text-white" />
                    )}
                    <p className="fs-14 fw-500 text-white ms-3 my-auto">{capitalize(el.label)}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <button
            className="white-flat-btn d-block fw-bold py-2 px-4 m-auto mt-3 mb-2"
            type="button"
            onClick={this.passDetails}
          >
            Add
          </button>
        </form>
      </>
    );
  }
}

export default AddMoreDetails;
